import {Injectable} from '@angular/core';

@Injectable()
export class UploadMessagesService {
  errorMessages = {
    'file-size-exceeded': 'File size is too big.',
    'wrong-file-type': 'Wrong file type.',
    'file-dimensions-not-meet': 'File dimensions do not meet the criteria.',
    'file-exact-dimensions-not-meet': 'File exact dimensions do not meet the criteria.',
    'file-orientation-not-meet': 'File orientation do not meet the criteria.',
    'file-not-square': 'File is not square.',
    'file-upload-error': 'File was not uploaded.',
    'file-has-not-aspect-ratio': 'File aspect ratio in not as expected.',
  };

  constructor() {}
}
